import React, { useEffect, useRef, useState } from "react";
import NavbarCustom from "../../../Components/NavbarCustom";
import "./verifyOtp.css";
import { useNavigate } from "react-router-dom";
import { useForgetPassword } from "../../../APIContext/ForgetPasswordContext";

export default function VerifyOTP() {
  const { loading, email, functionVerifyOTP } = useForgetPassword();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [inEmail, setInEmail] = useState("");
  const navigate = useNavigate();

  // Create 6 refs for 6 input fields
  const inputRefs = useRef([]);

  useEffect(() => {
    if (email) {
      setInEmail(email);
    }
  }, [email]);

  // console.log(inEmail);

  const handleInput = (value, index) => {
    // Allow ONLY numbers
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus next box
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const verifyOtp = async () => {
    const fullOtp = otp.join("");

    if (fullOtp.length !== 6) {
      alert("Please enter the complete 6-digit OTP");
      return;
    }

    const data = {
      otp: fullOtp,
      email: inEmail,
    };

    try {
      await functionVerifyOTP(data);
      setIsDisabled(true);
    } catch (err) {
      console.error(err);
      alert("OTP verification failed");
    }
  };

  return (
    <>
      <NavbarCustom />

      <div className="otp-container">
        <div className="otp-header">
          <div className="otp-header-content">
            <h1 className="otp-heading black-text-clip">Verify OTP</h1>
            <p className="black-text-clip">Enter the 6-digit OTP sent to {email || "your email"}</p>
          </div>
        </div>

        {/* OTP Input Boxes */}
        <div className="otp-box-container">
          {otp.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              className="otp-input-box"
              value={digit}
              ref={(el) => (inputRefs.current[index] = el)}
              onChange={(e) => handleInput(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
            />
          ))}
        </div>

        {/* Verify Button */}
        <div className="otp-btn-container">
          <button
            className="otp-btn"
            onClick={verifyOtp}
            disabled={isDisabled || loading}
            style={
              isDisabled || loading
                ? { background: "rgb(0 0 0 / 75%)", cursor: "not-allowed" }
                : {}
            }
          >
            {isDisabled || loading ? "Verifying..." : "Verify OTP"}
          </button>
        </div>
      </div>
    </>
  );
}
